import React, {useEffect, useState} from 'react';
import {useHistory, useParams} from 'react-router-dom';
import {Card, message} from 'antd';

import './certificate.scss';
import Cookies from 'universal-cookie';
import {applicationDetail} from "../../apis/admin";
import {getTokenHeader, replaceUrlByParams, setTokenHeader} from "../../utils/api";
import {userDetail} from "../../apis/result";
import {PAGE} from "../../utils/constants";
import boolean from "less/lib/less/functions/boolean";

function CertificatePage() {
    let history = useHistory()
    const cookies = new Cookies();
    const {portal, pid, id} = useParams()
    const [certificate, setCertificate] = useState({});
    const {adminToken} = getTokenHeader()
    setTokenHeader(adminToken, cookies.get('publicToken'))

    const loginPage = portal === 'admin' ? PAGE.ADMIN_LOGIN :  portal === 'user' ? `${replaceUrlByParams(PAGE.USER_LOGIN, {':pid': pid})}` : PAGE.ERROR


    useEffect(() => {
        getCertificate();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getCertificate = async () => {
        let api;
        if(portal === 'admin') {
            api = () => applicationDetail(pid, id)
        }else if(portal === 'user'){
            api = () => userDetail()
        }else{
            history.push(PAGE.ERROR)
        }

        try {
            const res = await api();
            if (res.error || res.applicationNumber !== id) {
                message.error('登入錯誤，請重新登入', 2,  () => history.push(loginPage))

                throw new Error(`${res.error.msgCode} - ${res.error.message}`);
            } else {
                res.sections.filter(e => e.result).filter(i => i.result.certificate).map((target) => {
                    setCertificate(target.result.certificate)
                })
            }
        } catch (e) {
            console.error(e);
        }
    };

    return (
        <>
            {certificate.title && (
                <Card
                    className='certificate-page'
                    title={certificate.title}
                >
                    <div className='flex-table'>
                        {
                            certificate.fields && certificate.fields.map((field, i) => {
                                return (
                                    <div key={i} className='cell'>
                                        <div className='label'>{field.name}</div>
                                        <div className='value'>{field.value}</div>
                                    </div>

                                )
                            })
                        }
                    </div>
                </Card>
            )}
        </>
    )
}

export default CertificatePage;
